module.exports = __webpack_public_path__ + "static/img/qiehuan.4f9d21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/qiehuan.png
// module id = AZBv
// module chunks = 1